import { memo } from "react";

import { TemplateVersion } from "types/generated";
import TableSimple from "ds/components/TableSimple";

import useTemplatesTableStore from "./useTemplateVersionsTableStore";
import { FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { TEMPLATE_VERSIONS_TABLE_CELLS } from "./Cells";
import { TEMPLATE_VERSIONS_SORT_CONFIG } from "./constants";

type TemplatesTableProps = {
  templates: TemplateVersion[];
  loading?: boolean;
  rowsPerPage: number;
};

const TemplatesTable = ({ templates, loading, rowsPerPage }: TemplatesTableProps) => {
  return (
    <TableSimple
      data={templates}
      loading={loading}
      store={useTemplatesTableStore}
      ariaLabel="Templates table"
      rowsPerPage={rowsPerPage}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      cellPerColumn={TEMPLATE_VERSIONS_TABLE_CELLS}
      sortConfig={TEMPLATE_VERSIONS_SORT_CONFIG}
    />
  );
};

export default memo(TemplatesTable);
